import { render, staticRenderFns } from "./ControlePlano.vue?vue&type=template&id=028e20f3&scoped=true&"
import script from "./ControlePlano.vue?vue&type=script&lang=js&"
export * from "./ControlePlano.vue?vue&type=script&lang=js&"
import style0 from "./ControlePlano.vue?vue&type=style&index=0&id=028e20f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028e20f3",
  null
  
)

export default component.exports